import React, { useContext, useState, useEffect } from 'react';

import clientOnly from '../../../../../src/common/hoc/clientOnly.js';
import { Link } from 'formlabs-web-components/Link';
import CookieConsent from 'react-cookie-consent';
import Cookies from 'js-cookie';

import { withTranslation } from 'react-i18next';

import './Cookie.module.css';
import CountryContext from '../../../../common/context/country';

const CookieConsentBar = ({ t }) => {
  const country = useContext(CountryContext);
  const [cookieExists, setCookieExists] = useState(true);

  useEffect(() => {
    // check if cookie does not exist
    if (!Cookies.get('formlabsCookieConsent')) {
      setCookieExists(false);
    }
  }, []);

  // create formlabs consent cookie
  const createConsentCookie = () => {
    Cookies.set('formlabsCookieConsent', 'true');
    setCookieExists(true);
  };

  if (cookieExists) {
    return null;
  }

  return (
    <section
      styleName={'cookie-consent-body'}
      aria-label={t('Cookie consent body text')}
    >
      <div styleName="cookie-container">
        <CookieConsent
          location="none"
          cookieName="formlabsCookieConsent"
          buttonStyle={{
            display: 'none'
          }}
          style={{
            color: '#000',
            backgroundColor: '#f3f3f3',
            position: 'static',
            width: 'auto',
            fontSize: '15px'
          }}
          expires={150}
        >
          <style
            dangerouslySetInnerHTML={{
              __html: `#drift-widget {bottom:70px !important}`
            }}
          />
          {t(
            'We serve cookies on this site to analyze traffic, remember your preferences, and optimize your experience.'
          )}
          <div className="cookie-button-container">
            <button onClick={createConsentCookie} styleName="cookie-button">
              {t('Ok')}
            </button>
            <Link to={`${country.path}privacy-policy/`}>
              <button styleName="cookie-button">{t('More Info')}</button>
            </Link>
          </div>
        </CookieConsent>
      </div>
    </section>
  );
};
export default clientOnly(withTranslation()(CookieConsentBar));
